import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { connect } from 'react-redux'
import moment from 'moment'
import { push } from 'connected-react-router'
import { compose } from 'recompose'

import { apiConfiguration } from 'helpers/decorators/api'
import { CONFIGURATION_KEYS } from 'constants/enums'
import activityMonitorStorage from 'helpers/activityMonitorStorage'
import appConfig from 'config'
import { getToken } from 'utils/token'
import { getActiveOrganization } from '../../../utils/token'


function hoc () {
  return ComposedComponent => {
    const enhance = compose(
      apiConfiguration(),
      connect(
        ({ auth }) => ({
          user: auth.user,
          activeOrganization: auth.organization
        }),
        { push }
      )
    )

    class ActivityMonitor extends Component {
      static propTypes = {
        push: PropTypes.func.isRequired,
        onGetConfigurationValue: PropTypes.func.isRequired,
        user: PropTypes.object,
        activeOrganization: PropTypes.object,
        configuration: PropTypes.object
      }

      state = {
        interval: null
      }

      // componentWillMount = () => {
      //   if (
      //     getToken(this.props.user) &&
      //     __CLIENT__ &&
      //     sessionStorage &&
      //     !sessionStorage.getItem('boUserLoginId')
      //   ) {
      //     this.props.push({
      //       pathname: '/logout',
      //       state: {
      //         inactivity: true,
      //         reason:
      //           'You have been logged out because session has been terminated',
      //         reasonIntlKey:
      //           'moduleTitle.you_have_been_logged_out_session_terminated'
      //       }
      //     })
      //   }
      // }

      componentDidMount = () => {
        const { user, configuration, onGetConfigurationValue } = this.props

        if (getToken(user)) {
          const organization = getActiveOrganization(user)
          onGetConfigurationValue(CONFIGURATION_KEYS.boWebLogout.id, get(organization, 'id'))
        }


        const timerMinutes = get(
          configuration,
          'values[CONFIGURATION_KEYS.boWebLogout.id].intValue'
        )
        // const lastActivity = JSON.parse(store.get('lastActivity'))
        // const tokenExp = moment(get(user, 'exp'))
        //   .utc()
        //   .format()

        // if (
        //   lastActivity &&
        //   tokenExp &&
        //   moment(lastActivity)
        //     .utc()
        //     .isAfter(tokenExp)
        // ) {
        //   this.handleLogout()
        // }

        timerMinutes &&
        get(user, 'access_token') &&
        this.setState({
          interval: this.startInterval(timerMinutes)
        })
      }

      componentWillReceiveProps = nextProps => {
        const { configuration } = this.props
        const currentTimerConfigValue = get(
          configuration.values[CONFIGURATION_KEYS.boWebLogout.id],
          'intValue'
        )
        const newTimerConfigValue = get(
          nextProps.configuration.values[CONFIGURATION_KEYS.boWebLogout.id],
          'intValue'
        )

        const isUserNewlyLoggedIn =
          !get(this.props, 'user.access_token') &&
          get(nextProps, 'user.access_token') &&
          newTimerConfigValue

        const isUserNewlyLoggedInWithoutConfig =
          !get(this.props, 'activeOrganization.id') &&
          get(nextProps, 'activeOrganization.id') &&
          !newTimerConfigValue

        const isConfigLoaded =
          !currentTimerConfigValue &&
          newTimerConfigValue &&
          get(nextProps, 'user.access_token')

        if (isUserNewlyLoggedIn || isConfigLoaded) {
          this.setState({
            interval: this.startInterval(
              get(
                nextProps.configuration.values[
                  CONFIGURATION_KEYS.boWebLogout.id
                  ],
                'intValue'
              )
            )
          })
        }

        if (isUserNewlyLoggedInWithoutConfig) {
          this.props.onGetConfigurationValue(CONFIGURATION_KEYS.boWebLogout.id)
        }
      }

      componentDidUpdate = prevProps => {
        const isUserNewlyLoggedOut =
          get(prevProps, 'user.access_token') &&
          !get(this.props, 'user.access_token') &&
          this.state.interval

        if (isUserNewlyLoggedOut) {
          clearInterval(this.state.interval)
          console.log('Activity monitor stopped!')
        }
      }

      startInterval = logoutAfter => {
        activityMonitorStorage.resetLastActivity()
        console.log('Activity monitor initialized', logoutAfter)
        const logoutInSeconds = logoutAfter * 60

        const intervalPeriod = 30000

        return setInterval(async() => {
          const lastActivity = moment(await activityMonitorStorage.getLastActivity())
          if (lastActivity && lastActivity.isValid()) {
            if (moment().diff(lastActivity, 'seconds', true) > logoutInSeconds) {
              clearInterval(this.state.interval)
              console.log('User inactive!')

              this.handleLogout()
            }
          }
        }, intervalPeriod)
      }

      handleLogout = () => {
        this.props.push({
          pathname: `${appConfig.publicPath}/logout`,
          state: {
            inactivity: true,
            reason: 'You have been logged out due to inactivity',
            reasonIntlKey: 'moduleTitle.you_have_been_logged_out_due_to_inactivity'
          }
        })
      }

      render () {
        return <ComposedComponent {...this.props} />
      }
    }

    return enhance(ActivityMonitor)
  }
}

export default hoc
